const useCards = () => true;

export default useCards;
